export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6485.9114ac61.jpg";